import React, { useEffect, useContext } from 'react';
import { Context } from 'context';
import { LOGOUT } from 'context/actions';

const Logout = () => {
    const { dispatch } = useContext(Context);

    useEffect(() => {
        dispatch({ type: LOGOUT });
    }, []);

    return null;
};

export default Logout;